import { Map } from 'immutable';

import { ActionTypes } from '../constants/AppConstants';
import BaseStore from './BaseStore';

import KeyGoForm from '../records/customer/KeyGoForm';

class KeyGoStore extends BaseStore {

    getInitialState () {
        const form = new KeyGoForm();
        const validation = new Map(form.getValidationSummary());
        return new Map({ form, validation });
    }

    updateForm (form) {
        const validation = this.get('validation').merge(form.getValidationSummary());
        this.setState(this.state.merge({ form, validation }));
    }

    handlePaymentFormChanged ({ field, value }) {
        const form = this.get('form').set(field, value);
        this.updateForm(form);
    }

    handlePaymentAddressSelected({ address }) {
        const form = this.get('form').merge({
            addressLine1: address.get('line1'),
            addressLine2: address.get('line2'),
            addressLine3: address.get('line3'),
            townCity: address.get('town'),
            postcode: address.get('postCode')
        });
        this.updateForm(form);
    }

    handlePaymentSucceeded () {
        this.setState(this.getInitialState().merge({
            paymentSucceeded: true
        }));
    }

    handlePaymentFormRetry () {
        this.setState(this.state.remove('error'));
    }

    handlePropertyChange (name) {
        return (payload) => this.setState(this.state.set(name, payload[name]));
    }

    handleSmartcardStatus ({smartcard}) {
        if (smartcard && !smartcard.isAwaitingProduct()) {
            const form = this.get('form').set('showCollectionLocation', true);
            this.setState(this.state.merge({
                form,
                validation: this.get('validation').merge(form.getValidationSummary())
            }));
        }
    }

    handleSetShowCollectionLocation({ showCollectionLocation }) {
        this.setState(this.state.merge({ form: this.get('form').set('showCollectionLocation', !!showCollectionLocation) }));
    }

    getActionHandlers () {
        return {
            [ActionTypes.KEYGO_FORM_CHANGED]: this.handlePaymentFormChanged,
            [ActionTypes.KEYGO_ADDRESS_SELECTED]: this.handlePaymentAddressSelected,
            [ActionTypes.KEYGO_FORM_RETRY]: this.handlePaymentFormRetry,
            [ActionTypes.KEYGO_REGISTRATION_COMPLETE]: this.handlePaymentSucceeded,
            [ActionTypes.KEYGO_UPDATE_COMPLETE]: this.handlePaymentSucceeded,
            [ActionTypes.KEYGO_REGISTRATION_FAILED]: this.handlePropertyChange('error'),
            [ActionTypes.KEYGO_UPDATE_FAILED]: this.handlePropertyChange('error'),
            [ActionTypes.KEYGO_FORM_RESET]: this.resetState,
            [ActionTypes.LOGGED_OUT]: this.resetState,
            [ActionTypes.SMARTCARD_LOADED]: this.handleSmartcardStatus,
            [ActionTypes.SMARTCARD_SET_SHOW_COLLECTION_LOCATION]: this.handleSetShowCollectionLocation
        };
    }

}

export default new KeyGoStore();



// WEBPACK FOOTER //
// ./src/stores/KeyGoStore.js